import { useState } from 'react';
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
} from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers';
import { Grid } from '@mui/material';
import { DateTime } from 'luxon';
import TuneIcon from '@mui/icons-material/Tune';
import AddIcon from '@mui/icons-material/Add';
import ReportSettingForm from './ReportSettingForm';
import { useNavigate } from 'react-router-dom';

const ReportSettings = ({
  report,
  dateStart,
  dateEnd,
  setDateStart,
  setDateEnd,
  allSettings,
  selectedSetting,
  setSelectedSetting,
}) => {
  const navigate = useNavigate();
  const [showSettings, setShowSettings] = useState(false);

  const handleSetDate = (num, value) => {
    if (num === 1) {
      //дата начала периода
      setDateStart(value.toISO());
    }
    if (num === 2) {
      //дата окончания периода
      setDateEnd(value.toISO());
    }
  };

  const handleSelectSetting = (event) => {
    const settingId = event.target.value;
    if (settingId) {
      const settingObj = allSettings.find((s) => s._id === settingId);
      setSelectedSetting(settingObj || '');
    } else {
      setSelectedSetting('');
    }
  };

  const handleAddClick = (event) => {
    navigate(`./new`);
  };

  const handleTuneClick = () => {
    if (selectedSetting?._id) {
      navigate(`./${selectedSetting._id}`);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        p: 1,
        //   mt: 2,
      }}
    >
      {showSettings ? (
        <ReportSettingForm
          selectedSettingId={selectedSetting?._id || ''}
          setShowSettings={setShowSettings}
        />
      ) : (
        <>
          {report?.usePeriod && (
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            >
              <Grid item sm={6} md={6} xs={6} sx={{ mb: 1 }}>
                <MobileDatePicker
                  label='Начало периода'
                  // autoOk='true'
                  disableFuture={true}
                  // disableCloseOnSelect={false}
                  value={DateTime.fromISO(dateStart)}
                  onChange={(newValue) => handleSetDate(1, newValue)}
                  sx={{ width: '100%' }}
                />
              </Grid>
              <Grid item sm={6} md={6} xs={6} sx={{ mb: 1 }}>
                <MobileDatePicker
                  label='Конец периода'
                  disableFuture={true}
                  // disableCloseOnSelect={false}
                  value={DateTime.fromISO(dateEnd)}
                  onChange={(newValue) => handleSetDate(2, newValue)}
                  sx={{ width: '100%' }}
                />
              </Grid>
            </Grid>
          )}
          <Grid
            container
            rowSpacing={0}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
          >
            <Grid item sm={10} md={10} xs={10}>
              <FormControl sx={{ width: '100%' }}>
                <InputLabel id='setting-select-label'>Настройка</InputLabel>
                <Select
                  labelId='setting-select-label'
                  id='setting-selector'
                  value={selectedSetting?._id || ''} // Строка ID!
                  onChange={handleSelectSetting}
                  input={<OutlinedInput label='Настройка' />}
                >
                  <MenuItem value=''>
                    <em>Выберите или создайте настройку</em>
                  </MenuItem>
                  {allSettings.map((set) => (
                    <MenuItem
                      key={set._id}
                      value={set._id}
                      sx={{
                        whiteSpace: 'normal', // ← главное — разрешаем перенос
                        wordBreak: 'break-word', // разбиваем очень длинные слова
                        // или более мягкий вариант:
                        // overflowWrap: 'break-word',
                        hyphens: 'auto', // опционально: расставляет переносы (работает не везде)
                        maxWidth: '100%', // на всякий случай
                      }}
                    >
                      <ListItemText
                        primary={set.title}
                        primaryTypographyProps={{
                          style: {
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                          },
                        }}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* ← Вот здесь responsive Stack для иконок */}
            <Grid item sm={2} md={2} xs={2} alignContent={'center'}>
              <Stack
                direction={{ xs: 'column', sm: 'row' }} // xs — мобильный: вертикально, sm и выше — горизонтально
                spacing={1} // расстояние между иконками
                alignItems={{ xs: 'flex-start', sm: 'center' }} // на мобильном — слева, на десктопе — по центру
                sx={{
                  // чтобы иконки не растягивались на мобильном
                  width: { xs: 'auto', sm: 'auto' },
                }}
              >
                <IconButton size='small' onClick={handleAddClick}>
                  <AddIcon />
                </IconButton>

                {selectedSetting && (
                  <IconButton size='small' onClick={handleTuneClick}>
                    <TuneIcon />
                  </IconButton>
                )}
              </Stack>
            </Grid>
            {/* </Box> */}
          </Grid>
        </>
      )}
    </Box>
  );
};

export default ReportSettings;
